import { InputLabel, MenuItem, Select, TableContainer } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Alert, Box, IconButton, Menu, Snackbar } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import React, { useEffect, useState } from 'react';
import { spaceTypes } from '../../constants/data';
import { withFirebase } from '../Firebase';
import { naturalCompare } from '../Spaces/utils';
import BulkManageDrawer from './BulkManageDrawer';
import SpaceImportWizard from './SpaceImportWizard';
import SpacesDrawer from './spacesDrawer';

const useStyles = makeStyles((theme) => ({
   formControl: {
      width: 200,
   },
   blueTable: {
      backgroundColor: '#342E76',
      color: '#fff',
   },
   paper: {
      width: '100%',
      padding: theme.spacing(2),
   },
   input: {
      marginLeft: theme.spacing(1),
      flex: 1,
   },
   iconButton: {
      padding: 10,
   },
   rowHover: {
      '&$hover:hover': {
         cursor: 'pointer',
      },
   },
   hover: {
      cursor: 'pointer',
   },
}));

const SpacesPanel = (props) => {
   const classes = useStyles();
   const [spacesEnabled, setSpacesEnabled] = useState(false);
   const [spacesExist, setSpacesExist] = useState(false);
   const [spacesDrawerOpen, setSpacesDrawerOpen] = useState(false);
   const [spaceKey, setSpaceKey] = useState(null);
   const [refresh, setRefresh] = useState(false);
   const [allSpaces, setAllSpaces] = useState({ loading: 'Loading...' });
   const [filter, setFilter] = useState({ archive: 2, type: '', search: '' });

   // --- New state for import wizard, bulk manage, and dropdown menu ---
   const [importWizardOpen, setImportWizardOpen] = useState(false);
   const [bulkManageOpen, setBulkManageOpen] = useState(false);
   const [menuAnchorEl, setMenuAnchorEl] = useState(null);
   const menuOpen = Boolean(menuAnchorEl);

   // Local snackbar (since setSnackBar isn't passed from parent)
   const [snackBar, setSnackBar] = useState({
      display: false,
      type: 'success',
      message: '',
   });
   const snackbarClose = (event, reason) => {
      if (reason === 'clickaway') return;
      setSnackBar({ ...snackBar, display: false });
   };

   useEffect(() => {
      if (props.expanded === 'spaces') {
         let query = props.firebase.spaces(props.locationKey);
         if (filter.archive === 2) {
            query = query.where('archive', '==', false);
         }
         if (filter.archive === 3) {
            query = query.where('archive', '==', true);
         }
         if (filter.type !== '') {
            query = query.where('type', '==', filter.type);
         }
         props.firebase.location(props.locationKey).onSnapshot(
            (result) => {
               if (result.data().spacesEnabled === true) {
                  setSpacesEnabled(true);
                  query.onSnapshot(
                     (spaceResult) => {
                        if (spaceResult.empty != true) {
                           let data = [];
                           spaceResult.forEach((doc) => {
                              data.push({
                                 ...doc.data(),
                                 sid: doc.id,
                                 type: spaceTypes[doc.data().type],
                              });
                           });

                           data.sort((a, b) => {
                              if (a.order && b.order) {
                                 return a.order - b.order;
                              } else {
                                 return naturalCompare(a.name, b.name);
                              }
                           });

                           setAllSpaces(data);
                           setSpacesExist(true);
                        } else {
                           setSpacesExist(false);
                        }
                     },
                     (error) => {
                        console.log(error);
                     },
                  );
               } else {
                  setSpacesEnabled(false);
               }
            },
            (error) => {
               console.log(error);
            },
         );
         setRefresh(true);
      }
   }, [props.expanded, filter]);

   const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFilter({ ...filter, [name]: value });
   };
   const handleFormat = (event, value) => {
      setFilter({ ...filter, archive: value });
   };
   const submitSearch = (e) => {
      setFilter({ ...filter, search: e.target.value });
   };
   const ListSpaces = (props) => {
      return (
         <Grid item xs={12}>
            <TableContainer style={{ maxHeight: 400 }}>
               <Table size="small" aria-label="Spaces table" stickyHeader>
                  <TableHead>
                     <TableRow>
                        <TableCell className={classes.blueTable}>Space</TableCell>
                        <TableCell className={classes.blueTable} align="left">
                           Description
                        </TableCell>
                        <TableCell className={classes.blueTable} align="left">
                           Seats
                        </TableCell>
                        <TableCell className={classes.blueTable} align="left">
                           Type
                        </TableCell>
                        <TableCell className={classes.blueTable} align="left">
                           Colour
                        </TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {allSpaces.map((value) => (
                        <React.Fragment key={value.sid}>
                           <TableRow
                              className={classes.rowHover}
                              hover
                              onClick={() => {
                                 setSpacesDrawerOpen(true);
                                 setSpaceKey(value.sid);
                              }}
                           >
                              <TableCell align="left">
                                 <Typography variant="body1">
                                    {value.archive ? (
                                       <ArchiveOutlinedIcon
                                          style={{
                                             position: 'relative',
                                             top: 6,
                                             marginRight: 6,
                                          }}
                                          color="action"
                                          size="small"
                                       />
                                    ) : (
                                       ''
                                    )}
                                    {value.name}
                                 </Typography>
                              </TableCell>
                              <TableCell style={{ maxWidth: 300 }} align="left">
                                 <Typography variant="caption">
                                    {value.description}
                                 </Typography>
                              </TableCell>
                              <TableCell align="left">
                                 <Typography variant="body1">
                                    {value.seats ? value.seats : ''}
                                 </Typography>
                              </TableCell>
                              <TableCell align="left">
                                 <Typography variant="body1">{value.type}</Typography>
                              </TableCell>
                              <TableCell align="left">
                                 <Box
                                    sx={{
                                       width: 25,
                                       height: 25,
                                       backgroundColor: value.backgroundColor
                                          ? value.backgroundColor
                                          : '#fff',
                                       border: `2px solid #eee`,
                                    }}
                                 ></Box>
                              </TableCell>
                           </TableRow>
                        </React.Fragment>
                     ))}
                  </TableBody>
               </Table>
            </TableContainer>
         </Grid>
      );
   };

   function toggleSpaces(lid, initialStatus) {
      var status = false;
      if (initialStatus === false) {
         status = true;
      }
      props.firebase.locationToggleSpaces(lid, status);
   }

   return (
      <React.Fragment>
         <Grid container>
            <Grid container item xs={12}>
               {spacesEnabled && (
                  <React.Fragment>
                     <Grid item xs={12} sm={4} md={2}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                           <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => {
                                 setSpacesDrawerOpen(true);
                              }}
                           >
                              New Space
                           </Button>
                           <IconButton
                              size="small"
                              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
                           >
                              <MoreVertIcon />
                           </IconButton>
                           <Menu
                              anchorEl={menuAnchorEl}
                              open={menuOpen}
                              onClose={() => setMenuAnchorEl(null)}
                           >
                              <MenuItem
                                 onClick={() => {
                                    setMenuAnchorEl(null);
                                    setImportWizardOpen(true);
                                 }}
                              >
                                 <ListItemIcon>
                                    <FileUploadIcon fontSize="small" />
                                 </ListItemIcon>
                                 <ListItemText>Import from CSV</ListItemText>
                              </MenuItem>
                              <MenuItem
                                 onClick={() => {
                                    setMenuAnchorEl(null);
                                    setBulkManageOpen(true);
                                 }}
                              >
                                 <ListItemIcon>
                                    <EditNoteIcon fontSize="small" />
                                 </ListItemIcon>
                                 <ListItemText>Bulk Manage Spaces</ListItemText>
                              </MenuItem>
                           </Menu>
                        </Box>
                     </Grid>
                  </React.Fragment>
               )}
               <Grid item xs={12} sm={6} md={8}>
                  <Typography variant="caption">
                     Spaces are office resources that can be booked, e.g. a desk, room, or
                     parking space. Spaces can have any number of seats which can be
                     reserved individually. Multiple spaces can be groupeed together in an
                     Area as a parent space, e.g. a desk can exist within a quiet working
                     area, on the first floor.
                  </Typography>
               </Grid>
               <Grid item xs={12} sm={2}></Grid>
            </Grid>
            <Paper variant="outlined" className={classes.paper}>
               <Grid container spacing={2} item xs={12}>
                  <Grid item xs={12} sm={12} md={2}>
                     <Typography variant="body2">Filters:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={5}>
                     <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.formControl}
                     >
                        <InputLabel htmlFor="outlined-type-native-simple">
                           Type
                        </InputLabel>
                        <Select
                           name="type"
                           value={filter.type}
                           onChange={handleInputChange}
                           labelId="Type"
                        >
                           <MenuItem aria-label="None" value="">
                              All
                           </MenuItem>
                           {Object.entries(spaceTypes).map(([key, type]) => (
                              <MenuItem key={key} value={key}>
                                 {type}
                              </MenuItem>
                           ))}
                        </Select>
                     </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={5}>
                     <div>
                        <ToggleButtonGroup
                           value={filter.archive}
                           exclusive
                           onChange={handleFormat}
                           aria-label="archived status"
                           size="small"
                           label="Status"
                        >
                           <ToggleButton value={1} aria-label="all">
                              All
                           </ToggleButton>
                           <ToggleButton value={2} aria-label="active">
                              Active
                           </ToggleButton>
                           <ToggleButton value={3} aria-label="archived">
                              Archived
                           </ToggleButton>
                        </ToggleButtonGroup>
                     </div>
                  </Grid>
               </Grid>
            </Paper>
            <Grid container item xs={12}>
               {spacesExist ? <ListSpaces classes={classes} /> : 'No results'}
            </Grid>
         </Grid>

         <SpacesDrawer
            locationKey={props.locationKey}
            cid={props.cid}
            spaceKey={spaceKey}
            setSpaceKey={setSpaceKey}
            setSpacesDrawerOpen={setSpacesDrawerOpen}
            spacesDrawerOpen={spacesDrawerOpen}
         />

         {/* CSV Import Wizard */}
         <SpaceImportWizard
            open={importWizardOpen}
            onClose={() => setImportWizardOpen(false)}
            locationId={props.locationKey}
            setSnackBar={setSnackBar}
         />

         {/* Bulk Manage Drawer */}
         <BulkManageDrawer
            open={bulkManageOpen}
            onClose={() => setBulkManageOpen(false)}
            locationId={props.locationKey}
            companyId={props.cid}
            setSnackBar={setSnackBar}
         />

         {/* Local Snackbar */}
         <Snackbar
            open={snackBar.display}
            autoHideDuration={6000}
            onClose={snackbarClose}
         >
            <Alert
               onClose={snackbarClose}
               severity={snackBar.type}
               sx={{ width: '100%' }}
            >
               {snackBar.message}
            </Alert>
         </Snackbar>
      </React.Fragment>
   );
};

export default withFirebase(SpacesPanel);
